/**
 * Parent-domain cookie utilities for the split-app + Lambda@Edge hosting
 * pattern. Lambda@Edge validates `fe_access_token` on every `/app/*` request,
 * but Frontegg stores its tokens on `.auth.<domain>`, which the edge can't read.
 * These helpers mirror the token onto a cookie on the registrable parent domain
 * so the edge can validate it.
 *
 * Not every consumer hosts this way — a plain SPA imports `AuthProvider`/`useAuth`
 * without these. Hence these live as plain exports, not part of the required surface.
 */

export const ACCESS_TOKEN_COOKIE = 'fe_access_token';

/**
 * Reduce a hostname to its registrable parent domain, dotted for cookie sharing:
 * `app.tunesecurity.com` → `.tunesecurity.com`. Pure; the unit-tested core.
 */
export function parseCookieDomain(hostname: string): string {
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    return '.' + parts.slice(-2).join('.');
  }
  return hostname;
}

function getCookieDomain(): string {
  return parseCookieDomain(window.location.hostname);
}

export function setAccessTokenCookie(token: string): void {
  const domain = getCookieDomain();
  document.cookie = `${ACCESS_TOKEN_COOKIE}=${token}; domain=${domain}; path=/; secure; samesite=lax`;
}

export function clearAccessTokenCookie(): void {
  const domain = getCookieDomain();
  document.cookie = `${ACCESS_TOKEN_COOKIE}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; samesite=lax`;
}
